import React from 'react';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid';
import TypesIndicateurs from './TypesIndicateurs';
import { fetchTypeIndicateursIfNeeded } from 'store/type/indicateursActions';

class TypesIndicateursContainer extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            selectedGroupeIndexes: [0]
        };
    }


    componentDidMount() {
        this.props.fetchTypeIndicateursIfNeeded();
    }


    componentDidUpdate(prevProps) {
        if (this.props.didInvalidate && !prevProps.didInvalidate) {
            this.props.fetchTypeIndicateursIfNeeded();
        }
    }

    handleGroupeChange = event => {
        this.setState({ ...this.state, selectedGroupeIndexes: event.target.value.sort((a, b) => a >= b) });
    }

    render() {
        
        return (
            <Grid item xs={12}>
                <TypesIndicateurs {...this.props} selectedGroupeIndexes={this.state.selectedGroupeIndexes} onGroupeChange={this.handleGroupeChange}/>
            </Grid>
        );
    }
}

const mapStateToProps = state => ({
    groupes: state.type.indicateurs.items,
    isLoading: state.type.indicateurs.isLoading,
    didInvalidate: state.type.indicateurs.didInvalidate
});

const mapDispatchToProps = dispatch => ({
    fetchTypeIndicateursIfNeeded: () => dispatch(fetchTypeIndicateursIfNeeded())
});

export default connect(mapStateToProps, mapDispatchToProps)(TypesIndicateursContainer);